export default {
  category_name: 'Acquista gift card',
};
